<template>
  <div class="card">
    <div class="card-body">
      <!-- Nav tabs -->
      <!-- <div class="row mb-3">
        <div class="col-sm-3">
          <multiselect
            v-model="filters.status"
            label="name"
            track-by="value"
            :options="filters.statusOptions"
            :searchable="false"
            :close-on-select="false"
            :show-labels="false"
            :allow-empty="false"
            placeholder="Կարգավիճակ"
          />
        </div>
      </div> -->
      <!-- Tab panes -->
      <div class="row">
        <div class="col-12 tenders-list">
          <v-server-table
            ref="vtable"
            :url="`${proxyUrl}suggestions/get`"
            :options="options"
            :columns="columns"
          >
            <div slot="name" class="more d-flex justify-content-center" slot-scope="{row}">
              {{row.organize.name}}
            </div>
            <div slot="code" class="more d-flex justify-content-center" slot-scope="{row}">
              {{row.organize.code}}
            </div>
            <div slot="cpvs_count" class="d-flex justify-content-center" slot-scope="{row}">
              {{row.organize.organize_rows.length}}
            </div>
            <div slot="type" class="more d-flex justify-content-center" slot-scope="{row}">
              {{row.is_itender ? 'iTender մրցույթներ' : 'Պետական մեկ անձի մրցույթներ'}}
            </div>
            <div slot="winner_determining_type" class="more d-flex justify-content-center" slot-scope="{row}">
              {{row.organize.winner_by_lots ? 'Ըստ չափաբաժինների' : 'Ըստ ընդհանուր գնի'}}
            </div>
            <div slot="customer" class="d-flex justify-content-center" slot-scope="{row}">
              {{row.client.name}}
            </div>
            <div slot="status" class="d-flex justify-content-center" slot-scope="{row}">
              {{row.organize.status === 'finished' ? 'Ավարտված' : 'Ընթացիկ' }}
            </div>
            <div slot="end_date" class="d-flex justify-content-center" slot-scope="{row}">
              {{row.organize.finish_date}}
            </div>
            <div slot="project" class="row justify-content-center" slot-scope="{row}">
              <div class="col mb-2">
                <template v-if="!row.organize.is_canceled">
                  <button v-if="row.organize.status !== 'finished'" type="button" @click="() => {$modal.show('suggestion-modal', {...row, resetComponent})}" data-toggle="modal" data-animation="bounce" class="w-100 btn btn-primary waves-effect waves-light mr-2 d-flex justify-content-center align-items-center">
                    Տեսնել գնային առաջարկը
                  </button>
                  <button v-else type="button" @click="() => {$modal.show('result-modal', {...row, resetComponent})}" data-toggle="modal" data-animation="bounce" class="w-100 btn btn-primary waves-effect waves-light mr-2 d-flex justify-content-center align-items-center">
                    Տեսնել արդյունքները
                  </button>
                  <button
                    v-if="row.organize && (row.organize.type === 'itender' && row.organize.report_document)"
                    @click.stop="() => { 
                      $modal.show('report-document-modal', {contract: row}) 
                    }"
                    type="button" 
                    class="btn btn-primary btn-sm col mt-2"
                  >
                    <i class="fas fa-file-alt mr-1" /> Հաշվետվություն
                  </button>
                  <div v-if="row.organize.status !== 'finished'" >
                    <button v-if="row.organize.contract !== ''" type="button" @click.stop="() => {$modal.show('contract-draft-modal', row)}" class="w-100 btn btn-primary waves-effect waves-light d-flex justify-content-center align-items-center mt-2" data-toggle="modal" data-animation="bounce">
                      <i class="fas fa-file-alt mr-1" /> Պայմանագիրի նախագիծ
                    </button>
                  </div>
                  <div v-else-if="isWinner(row)" class="col">
                    <button v-if="row.organize.contract !== ''" type="button" @click.stop="() => {$modal.show('contract-modal', row)}" class="w-100 btn btn-primary waves-effect waves-light d-flex justify-content-center align-items-center mt-2" data-toggle="modal" data-animation="bounce">
                      <i class="fas fa-file-alt mr-1" /> Պայմանագիր
                    </button>
                    <button v-if="!row.is_itender" type="button" @click.stop="() => {$modal.show('price-offer-modal', row)}" class="mt-2 w-100 btn btn-primary waves-effect waves-light d-flex justify-content-center align-items-center" data-toggle="modal" data-animation="bounce">
                      <i class="fas fa-file-alt mr-1" /> Գնային առաջարկ
                    </button>
                  </div>
                </template>
                <template v-else>
                  Ընթացակարգը չեղարկվել է, քանի որ <b>{{row.organize.cancel_reason}}</b>
                </template>
              </div>
            </div>
            <div slot="delete" class="d-flex justify-content-center" slot-scope="{row}">
              <i v-if="!row.organize.is_canceled && row.organize.status === 'active'"  @click.stop="deleteSuggestion(row)" class="fas fa-undo text-danger" style="font-size: 30px; cursor: pointer;"></i>
            </div>
          </v-server-table>
        </div>
        <result-modal />
        <suggestion-modal />
        <specification-modal />
        <contract-draft-modal />
        <price-offer-modal />
        <contract-modal />
        <row-specification-modal/>
        <report-document-modal />
      </div>
    </div>
  </div>
</template>

<script>
  import SuggestionModal from '../modals/SuggestionModal'
  import ResultModal from '../modals/ResultModal'
  import ContractDraftModal from '../modals/ContractDraftModal'
  import ContractModal from '../modals/ContractModal'
  import RowSpecificationModal from '@/components/modals/RowSpecificationModal'
  import PriceOfferModal from '../modals/PriceOfferModal'
  import SpecificationModal from '@/components/modals/SpecificationModal'
  import ReportDocumentModal from '@/components/modals/ReportDocumentModal'

  export default {
    data() {
      return {
        proxyUrl: process.env.VUE_APP_API_URL,
        columns: ['name', 'code', 'cpvs_count', 'type', 'winner_determining_type', 'customer', 'status', 'end_date', 'project', 'delete'],
        options: {
          requestAdapter (data) {
            return {
              limit: data.limit ? data.limit : 5,
              page: data.page,
              responded: 1,
            }
          },
          responseAdapter({data}) {
            return { 
                data: data.data, 
                count: data.count
              }
          },
          requestFunction(data) {
            return this.$client.get(this.url, {params: data})
            .catch(function (e) {this.dispatch('error', e)})
          },
          sortable: [],
          params:{ 
            component: this
          },
          // sortable: ['cpvs_count', 'code', 'type', 'customer', 'category', 'status', 'end_date'],
          columnsDropdown: false,
          pagination: { chunk: 1 },
          filterByColumn: false,
          dateColumns:['create_date','end_date'],
          dateFormat: "YYYY-mm-dd",
          headings: {
            cpvs_count: 'Չափաբաժինների քանակ',
            name: 'Ընթացակարգի անվանում',
            code: 'Ընթացակարգի ծածկագիր',
            type: 'Ընթացակարգի տեսակ',
            winner_determining_type: 'Հաղթողին որոշելու կարգը',
            customer: 'Պատվիրատու',
            category: 'Խումբ / Կատեգորիա',
            project: '',
            end_date: 'Վերջնաժամկետ',
            status: 'Կարգավիճակ',
            details: 'Մանրամասն',
            delete: '',
          },
          texts: {
            count:
            'Ցուցադրված է {from}֊ից {to}֊ը ընդհանուր {count} տողից|{count} տող|',
            first: 'Առաջին',
            last: 'Վերջին',
            filter: '',
            filterPlaceholder: 'Փնտրել',
            limit: '',
            page: 'Page:',
            noResults: 'Համընկնում չի գտնվել',
            noRequest: 'խնդրում ենք ընտրել առնվազն մեկ ֆիլտեր տվյալները ներբեռնելու համար',
            filterBy: 'փնտրել ըստ {column}',
            loading: 'Բեռնվում է...',
            defaultOption: 'ընտրել {column}',
            columns: 'Ընտրել դաշտերը',
          },
          filterable: false
        },
        filters: {
          status: { name: 'Բոլորը', value: 'all' },
          statusOptions: [
            { name: 'Բոլորը', value: 'all' },
            { name: 'Ակտիվ առաջարկներ', value: 'active' },
            { name: 'Ավարտված առաջարկներ', value: 'finished' },
          ],
        }
      }
    },
    components: {ReportDocumentModal, PriceOfferModal, ContractModal, ResultModal, SuggestionModal, SpecificationModal, ContractDraftModal, RowSpecificationModal},
    computed: {
      currentPlan() {
        return this.$store.getters['procurement/currentPlan']
      },
      locale() {
        return this.$store.getters['user/locale']
      },
      me() {
        return this.$store.getters['user/me']
      }
    },
    mounted() {
    },
    methods: {
      isWinner(row){
        if(row.organize.winners.length){
          const me = row.organize.winners.find(winner => winner.user_id === this.me.id)
          return Boolean(me && me.signed_contract_hy);
        } else {
          return false
        }
      },
      getBack(event, id) {
        event.stopPropagation();
        this.$fire({
          showCancelButton: true,
          title: "Զգուշացում",
          text: "Սույնով դուք չեղարկում եք ձեր գնառաջարկը, այն պահպանվելու է որպես սևագիր",
          type: "warning",
          confirmButtonText: 'Չեղարկել',
          cancelButtonText: 'Ետ',
        })
      },
      deleteSuggestion(suggestion) {
        const suggestionId = suggestion.id;
        this.$confirm(
          "Սույնով դուք չեղարկում եք ձեր գնառաջարկը", 
          "", 
          "warning", 
          {
            confirmButtonText: 'Շարունակել', 
            cancelButtonText: 'Փակել'
          }
        ).then(text => {
          console.log(suggestion)
          console.log(suggestionId)
          this.$store.dispatch('suggestions/cancel', {id: suggestionId }).then(async (response) => {
            this.resetComponent();
          })
        })
      },
      async resetComponent() {
        await this.$refs.vtable.refresh()
      },
    },
  }
</script>